<ng-container>
  <div class="field-container">
    <label class="form-label">{{labelText}}<span class="text-danger" *ngIf="required">*</span></label>
    <p-datepicker [(ngModel)]="value" size="small" placeholder="mm aaaa" class="w-full" appendTo="body" showIcon
      iconDisplay="input" dateFormat="MM yy" [disabled]="disabled" view="month"
      [ngClass]="recovery ? 'recover-data' : ''" (onSelect)="changeDate($event)" />
  </div>
</ng-container>